// Role constants — must mirror backend enum
export const ROLES = {
    SUPER_ADMIN:      "SUPER_ADMIN",
    SALES_AGENT:      "SALES_AGENT",
    OPS_ADMIN:        "OPS_ADMIN",
    FINANCE_ADMIN:    "FINANCE_ADMIN",
    PROVIDER_ADMIN:   "PROVIDER_ADMIN",
    PROVIDER_STAFF:   "PROVIDER_STAFF",   // Team Member (receptionist/admin, location-scoped)
    PROVIDER_EXPERT:  "PROVIDER_EXPERT",  // Expert (doctor/therapist, public profile, self-service)
    MEMBER:           "MEMBER",
};

// The default landing route per role after login
export const ROLE_HOME = {
    SUPER_ADMIN:     "/admin/dashboard",
    OPS_ADMIN:       "/admin/dashboard",
    FINANCE_ADMIN:   "/admin/dashboard",
    SALES_AGENT:     "/kiosk/sales",
    PROVIDER_ADMIN:  "/provider/dashboard",
    PROVIDER_STAFF:  "/provider/verify",
    PROVIDER_EXPERT: "/provider/expert/profile",
    MEMBER:          "/member/dashboard",
};

// What top-level URL prefix each role can access
export const ROLE_ALLOWED_PREFIXES = {
    SUPER_ADMIN:     ["/admin", "/provider", "/member", "/kiosk"],
    OPS_ADMIN:       ["/admin"],
    FINANCE_ADMIN:   ["/admin"],
    SALES_AGENT:     ["/kiosk", "/admin/dashboard"],
    PROVIDER_ADMIN:  ["/provider"],
    PROVIDER_STAFF:  ["/provider/verify", "/provider/visits", "/provider/team"],
    PROVIDER_EXPERT: ["/provider/expert"],
    MEMBER:          ["/member"],
};

export function canAccess(role, path) {
    if (!role) return false;
    const prefixes = ROLE_ALLOWED_PREFIXES[role] || [];
    return prefixes.some((p) => path === p || path.startsWith(p + "/") || path.startsWith(p));
}

export function homeFor(role) {
    return ROLE_HOME[role] || "/login";
}
